import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FieldSet } from 'common/components/Form';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import BookCalculatorMoneyInput from 'book-calculator/components/BookCalculatorMoneyInput';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import { handleUpdatedAttribute } from 'book-calculator/actions/handleUpdatedAttribute';
import { Icon } from '@99designs/common/components/Icon';

class ExtrasFieldset extends React.Component {
    updateStandardField(key, { isChecked, value }) {
        this.context.executeAction(handleUpdatedAttribute, {
            key: key,
            value: {
                is_required: isChecked,
                cost: value,
            },
        });
    }

    updateCustomField(key, { isChecked, value, title }) {
        const customFields = this.props.customCosts.slice();
        customFields[key].is_required = isChecked;
        customFields[key].cost = value;
        customFields[key].title = title;

        this.context.executeAction(handleUpdatedAttribute, {
            key: 'custom_costs',
            value: customFields,
        });
    }

    render() {
        return (
            <FieldSet twoColumn={false}>
                <div className="row">
                    <div className="column">
                        <Matrix large={2} normal={2} medium={2} small={1}>
                            {this.renderStandardFields()}
                            {this.renderCustomFields()}
                            {this.renderAddCustomFieldButton()}
                        </Matrix>
                    </div>
                </div>
            </FieldSet>
        );
    }

    renderStandardFields() {
        const { fields, intl } = this.props;

        return fields.map(field => (
            <MatrixItem key={field.key}>
                <BookCalculatorMoneyInput
                    title={intl.formatMessage({ id: `fields.extras.${field.key}.title` })}
                    description={intl.formatMessage({
                        id: `fields.extras.${field.key}.description`,
                    })}
                    value={field.cost}
                    moneyInputPlaceholder={
                        field.hasPlaceholder
                            ? intl.formatMessage({ id: 'fields.extras.money_input_placeholder' })
                            : null
                    }
                    isChecked={field.is_required}
                    onChange={({ isChecked, value, title }) => {
                        this.updateStandardField(field.key, { isChecked, value });
                    }}
                />
            </MatrixItem>
        ));
    }

    renderCustomFields() {
        return this.props.customCosts.map((customItem, idx) => (
            <MatrixItem key={idx}>
                <BookCalculatorMoneyInput
                    moneyInputPlaceholder={this.props.intl.formatMessage({
                        id: 'fields.extras.money_input_placeholder',
                    })}
                    key={idx}
                    title={customItem.title}
                    isTitleEditible={true}
                    value={customItem.cost}
                    isChecked={customItem.is_required}
                    onChange={({ isChecked, value, title }) => {
                        this.updateCustomField(idx, { isChecked, value, title });
                    }}
                />
            </MatrixItem>
        ));
    }

    renderAddCustomFieldButton() {
        return (
            <MatrixItem>
                <button
                    className="add-your-own-button"
                    type="button"
                    key="addButton"
                    onClick={this.addNewField.bind(this)}
                >
                    <FormattedMessage id="steps.extras.add_another" />
                    <div className="add-your-own-button__icon">
                        <Icon type={'plus-2'} />
                    </div>
                </button>
            </MatrixItem>
        );
    }

    addNewField() {
        const customFields = this.props.customCosts.slice();
        customFields.push({
            title: '',
            cost: 0,
            is_required: true,
        });

        this.context.executeAction(handleUpdatedAttribute, {
            key: 'custom_costs',
            value: customFields,
        });
    }
}

ExtrasFieldset.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

export default injectIntl(
    connectToStores(ExtrasFieldset, [BookCalculatorAttributesStore], (context, prop) => {
        const attributes = context.getStore(BookCalculatorAttributesStore).getState();

        return {
            fields: [Object.assign(attributes['isbn'], { key: 'isbn', hasPlaceholder: false })],
            customCosts: attributes['custom_costs'],
        };
    })
);
